module.exports = __webpack_public_path__ + "static/media/executive_summary_placeholder.274fbbf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/executive_summary_placeholder.jpg
// module id = 2081
// module chunks = 0